import { Outlet, useNavigate } from "react-router-dom";
import { ArrowLeft, MessageSquare, Search } from "lucide-react";

export default function MessagesStandaloneLayout() {
  const navigate = useNavigate();

  return (
    <div className="app-shell relative flex flex-col h-screen overflow-hidden bg-background">
      {/* ── Standalone top bar (no sidebar / no tab bar) ── */}
      <header
        className="flex h-16 shrink-0 items-center justify-between border-b border-border/70 bg-background/90 backdrop-blur-xl px-8"
      >
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/messages")}
            className="flex items-center gap-2 rounded-xl px-3 py-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors ring-1 ring-border bg-card"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </button>

          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]">
              <MessageSquare className="h-5 w-5 text-primary-foreground" />
            </div>
            <div className="hidden sm:block">
              <div className="text-sm font-black text-foreground leading-none">Messages</div>
              <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mt-0.5">
                Secure email / SMS
              </div>
            </div>
          </div>
        </div>

        {/* Visual-only search hint (the full global Ctrl/⌘K search lives in PracticeLayout). */}
        <div className="relative w-full max-w-md ml-6 hidden md:block">
          <div className="flex h-10 w-full items-center gap-3 rounded-xl border border-border bg-card px-4 text-left text-sm font-medium text-muted-foreground shadow-sm">
            <Search className="h-4 w-4 shrink-0" />
            <span className="flex-1 truncate">Search patients, charts, orders...</span>
            <span className="rounded-lg border border-border bg-background px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              Ctrl/⌘ K
            </span>
          </div>
        </div>

        <div className="w-10" />
      </header>

      <main className="relative flex-1 min-h-0 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}

